import React from 'react'

const Terminal = () => {
  return (
    <div className='row-start-3 w-full bg-drk01 h-full'>
        Terminal
    </div>
  )
}

export default Terminal